<div>
  <a class="dynamic-link" (click)="performLink()">link</a>
</div>
